import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  strict: debug,
  state: {
    introduction: [],
    calendar: [],
    locations: [],
    contacts: [],
    newsletter: [],
    history: [],
    preservation: [],
    membership: [],
    publications: [],
    pictures: [],
    links: [],
    officers: [],
  },
  mutations: {
    setIntroduction(state, introduction) {
      state.introduction = introduction;
    },
    setCalendar(state, calendar) {
      state.calendar = calendar;
    },
    setLocations(state, locations) {
      state.locations = locations;
    },
    setContacts(state, contacts) {
      state.contacts = contacts;
    },
    setNewsletter(state, newsletter) {
      state.newsletter = newsletter;
    },
    setHistory(state, history) {
      state.history = history;
    },
    setPreservation(state, preservation) {
      state.preservation = preservation;
    },
    setMembership(state, membership) {
      state.membership = membership;
    },
    setPublications(state, publications) {
      state.publications = publications;
    },
    setPictures(state, pictures) {
      state.pictures = pictures;
    },
    setLinks(state, links) {
      state.links = links;
    },
    setOfficers(state, officers) {
      state.officers = officers;
    },
  },
  actions: {},
});

